export default __webpack_public_path__ + "static/media/announcement_1.32d5e0ab.png";